import { NotFoundSticker } from '@/assets/images';

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-transparent overflow-y-auto">
      <NotFoundSticker className="flex-shrink-0" />
      <h1 className="text-[32px] font-bold text-brand-primary-darkest mt-10 mb-3">
        Oops! Page Not Found
      </h1>
      <span className="font-medium text-base text-neutral-n7">
        Sorry, we can&apos;t find the page you&apos;re looking for.
      </span>
    </div>
  );
};

export default NotFound;
